import { get } from 'lodash';
import { FieldError, useFormContext } from 'react-hook-form';

export const getErrorMessage = (error: any) =>
  Object.values(error)
    .map((value: any) => {
      if (value?.message) return value?.message;
      return undefined;
    })
    .filter(Boolean)
    .join(', ');

export const getBorderColor = ({ hasError, hasWarning, isExpanded }) => {
  if (hasError) return 'red.500';
  if (hasWarning) return 'orange.500';
  if (isExpanded) return;
  return 'transparent';
};

export const useFieldValidationStates = (
  name: string,
): {
  error: FieldError | undefined;
  isTouched: boolean;
  isInvalid: boolean;
} => {
  const {
    formState: { errors, touchedFields },
  } = useFormContext();

  const error = get(errors, name) as FieldError;
  const isTouched = get(touchedFields, name);
  const isInvalid = !!error;

  return { error, isTouched, isInvalid };
};
